import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    publishableKey: String,
    genericError: String,
    locale: String,
    billingInfos: Object,
  };

  static targets = [
    'details',
    'success',
    'error',
    'errorMessage',
    'buttonText',
    'spinner',
    'formContainer',
    'formError',
    'loading',
    'submitContainer',
  ];

  connect() {
    this.stripe = Stripe(this.publishableKeyValue, { locale: this.localeValue });
    this.initializePaymentForm();
  }

  async initializePaymentForm() {
    try {
      const response = await fetch('/authentication_required_payments', {
        method: 'POST',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        this.showError(this.genericErrorValue);
        return;
      }

      const data = await response.json();

      this.elements = this.stripe.elements({ clientSecret: data.client_secret });
      const paymentElement = this.elements.create('payment');
      paymentElement.mount(this.formContainerTarget);

      paymentElement.on('ready', () => {
        this.loadingTarget.classList.add('d-none');
        this.formContainerTarget.classList.remove('d-none');
        this.submitContainerTarget.classList.remove('d-none');
      });
    } catch (error) {
      this.showError(this.genericErrorValue);
    }
  }

  async submit() {
    this.buttonTextTarget.classList.add('d-none');
    this.spinnerTarget.classList.remove('d-none');
    this.formErrorTarget.classList.add('d-none');

    try {
      const { error, paymentIntent } = await this.stripe.confirmPayment({
        elements: this.elements,
        confirmParams: {
          return_url: window.location.href,
          payment_method_data: {
            billing_details: this.billingInfosValue,
          },
        },
        redirect: 'if_required',
      });

      if (error) {
        if (error.type === 'card_error' || error.type === 'validation_error') {
          this.formErrorTarget.textContent = error.message;
          this.formErrorTarget.classList.remove('d-none');
        } else {
          this.showError(error.message || this.genericErrorValue);
        }
      } else if (
        paymentIntent &&
        (paymentIntent.status === 'succeeded' || paymentIntent.status === 'processing')
      ) {
        this.showSuccess();
      } else {
        this.showError(this.genericErrorValue);
      }
    } catch (error) {
      this.showError(this.genericErrorValue);
    } finally {
      this.buttonTextTarget.classList.remove('d-none');
      this.spinnerTarget.classList.add('d-none');
    }
  }

  retry() {
    this.errorTarget.classList.add('d-none');
    this.detailsTarget.classList.remove('d-none');
    this.loadingTarget.classList.remove('d-none');
    this.formContainerTarget.classList.add('d-none');
    this.submitContainerTarget.classList.add('d-none');
    this.formContainerTarget.innerHTML = '';
    this.initializePaymentForm();
  }

  showSuccess() {
    this.detailsTarget.classList.add('d-none');
    this.successTarget.classList.remove('d-none');
  }

  showError(message) {
    this.detailsTarget.classList.add('d-none');
    this.errorMessageTarget.textContent = message;
    this.errorTarget.classList.remove('d-none');
  }
}
